namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailProgramovaFaze extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GProgramovaFazeReadDto;
        private newRecord: boolean;
        private detailObj: DetailProgramovaFazeObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailProgramovaFazeObj());
            this.detailObj.createBase({
                contentName: "detailProgramovaFaze",
                contentCaption: "jres:33000689",  //RC 33000682 : URL webové aplikace
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                tabs.push(this.detailObj.getAuditPristupuTab());
                tabs.push(this.detailObj.urlProgramoveFazeTab());
                tabs.push(this.detailObj.urlAdresaDalsiInformaceFazeTab());
                if (this.detailObj.isUzivatelskaFaze() == false) {
                    tabs.push(this.detailObj.instanceProgramoveFazeTab());
                    tabs.push(this.detailObj.parametryProFazeTab());
                }
            }
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                groups.push(this.detailObj.getAuditPristupuGroup());
                groups.push(this.detailObj.urlProgramoveFazeGroup());
                groups.push(this.detailObj.urlAdresaDalsiInformaceFazeGroup());
                if (this.detailObj.isUzivatelskaFaze() == false) {
                    groups.push(this.detailObj.instanceProgramoveFazeGroup());
                    groups.push(this.detailObj.parametryProFazeGroup());
                }
            }
            builder.withComponent<this>("DetailProgramovaFaze", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailProgramovaFazeObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GProgramovaFazeReadDto> {

        isUzivatelskaFaze(): boolean {
            if (this.data.faze)
                return this.data.faze_typ == 10 
            return false;
        }

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["faze"]
        }

        setSxsDetail(): string {
            return "{0}".format((this.data.faze) ? this.data.faze.toString() : "");
        }

        saveData(data: any, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.ProgramovaFaze.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailProgramovaFaze", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.ProgramovaFaze.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.faze_txt) ? this.data.faze_txt : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                {
                    favorite: true,
                    type: "static",
                    visible: this.options.newRecord == false,
                    caption: "jres:33000138",
                    icon: "fa-link",
                    children: [
                        { action: this.cnt.actions.actUzivatelskeVzkazy },
                        { action: this.cnt.actions.actZastupyFaze }
                    ]
                },
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" },
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actUzivatelskeVzkazy: {
                    caption: "jres:33000696", //RC 33000695 : Vzkazy pro tuto fázi
                    icon: "fa-bullhorn",
                    disabled: this.isUzivatelskaFaze(),
                    run: (ev, ctx) => {
                        this.vzkazyProUzivatele();
                    }
                },
                actZastupyFaze: {
                    caption: "jres:33000700", //RC 33000700 : Zástupy této fáze
                    icon: "fa-link",
                    disabled: this.isUzivatelskaFaze(),
                    run: (ev, ctx) => {
                        this.zastupyFaze();
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {
            
        }

        createForm() {
            this.MakeField("faze", {
                flag: this.createFlagNemenne(),
                validators: [
                    new Gordic.Validators.RegExp({ pattern: "^[A-Z0-9]*$" }),
                    this.createSpecialValidatorUzivatelskaFaze(),
                    this.createSpecialValidatorDelka()
                ]
            });
            this.MakeField("faze_txt");
            this.MakeSelectField("faze_typ", Gordic.Prefabs.Select.admGincfat(), { model: "model.faze_typ=value.faze_typ" })
            if (this.data.faze_typ == 0) {
                this.form.addRow("jres:33000211").addField("gstringbox", {
                    name: "verze",
                    disabled: true,
                    model: function (op, dto, opt) {
                        switch (op) {
                            case "apply":
                                $(this).gfield("setValue", "{0}.{1}".format(dto.verze, dto.sub_verze));
                                break;
                        }
                    }
                })
                this.MakeField("pocet_adm")
                this.MakeField("pocet_lic")
            } else if (this.data.faze_typ == 10) {
                this.MakeField("faze_adr")
                this.MakeField("faze_exe")
                this.MakeField("dat_do")
            }
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        instanceProgramoveFazeTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-instance-programove-faze",
                    title: "jres:29929931",
                    opened: true,
                    locked: true,
                    attachToContent: true,
                    group: { id: "_tab-instance-programove-faze" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamProgramovaInstance",
                    serverParams: {
                        Id: "SeznamProgramovaInstance",
                        faze: this.data.faze,
                        tabOpen: true
                    }
                }
            }
        }

        urlProgramoveFazeTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-url-programove-faze",
                    title: "jres:33000682",
                    opened: true,
                    locked: true,
                    group: { id: "_tab-url-programove-faze" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmUrlWeboveAplikace",
                    serverParams: {
                        Id: "SeznamProgramovaInstance",
                        faze: this.data.faze,
                        tabOpen: true
                    }
                }
            }
        }

        urlAdresaDalsiInformaceFazeTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-url-dalsi-informace-faze",
                    title: "jres:33000684",
                    opened: true,
                    locked: true,
                    group: { id: "_tab-url-dalsi-informace-faze" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmUrlAdresaDalsiInformaceFaze",
                    serverParams: {
                        Id: "SeznamAdmUrlAdresaDalsiInformaceFaze",
                        faze: this.data.faze,
                        tabOpen: true
                    }
                }
            }
        }

         parametryProFazeTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-parametry-faze",
                    title: "jres:33000697", //RC 33000697 : Parametry fáze
                    opened: true,
                    locked: true,
                    group: { id: "_tab-parametry-faze" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmParametrGlobal",
                    serverParams: {
                        Id: "SeznamAdmParametrGlobal",
                        faze: this.data.faze,
                        uroven_cfg: 38,
                        tabOpen: true
                    }
                }
            }
         }

        instanceProgramoveFazeGroup(): IGTabGroupOptions {
            return { id: "_tab-instance-programove-faze", caption: "jres:29929931" }
        }

        urlProgramoveFazeGroup(): IGTabGroupOptions {
            return { id: "_tab-url-programove-faze", caption: "jres:33000682" }
        }

        urlAdresaDalsiInformaceFazeGroup(): IGTabGroupOptions {
            return { id: "_tab-url-dalsi-informace-faze", caption: "jres:33000684" }
        }

        parametryProFazeGroup(): IGTabGroupOptions {
            return { id: "_tab-parametry-faze", caption: "jres:33000697" }
        }

        private vzkazyProUzivatele() {
            this.cnt.navigate(["Gordic.Ozn.WebClient.GMessageList", { faze: this.data.faze }])
        }

        private zastupyFaze() {
            this.cnt.navigate(["Gordic.Adm.WebControls.SeznamZastup", { faze: this.data.faze }], { ID: "SeznamZastup" })
        }

        private createSpecialValidatorUzivatelskaFaze(): Gordic.Validators.Base {
            return new Gordic.Validators.Base({
                message: "jres:33000724", //RC 33000724 : Uživatelská fáze musí začínat na USR.
                validate: (value) => {
                    if (value.substring(0, 3) != "USR")
                        return false;
                    return true;
                }
            })
        }

        private createSpecialValidatorDelka(): Gordic.Validators.Base {
            return new Gordic.Validators.Base({
                message: "jres:33000725", //RC 33000725 : Uživatelská fáze musí mít 7 nebo 8 znaků.
                validate: (value) => {
                    if (value.length == 7 || value.length == 8)
                        return true;
                    return false;
                }
            })
        }
    }
}